var exports = {
  "X": "stickyContainer__z0yyZS",
};

module.exports = exports;
